
import React from 'react';
import { Badge } from "@/components/ui/badge";

interface BookingStatusBadgeProps {
  status: string;
  isCompleted: boolean;
  isCancelled: boolean;
  isCheckedIn: boolean;
}

export const BookingStatusBadge = ({ 
  status, 
  isCompleted, 
  isCancelled, 
  isCheckedIn 
}: BookingStatusBadgeProps) => {
  console.log('BookingStatusBadge called with:', { status, isCompleted, isCancelled, isCheckedIn });
  
  // Always check database status first - this takes priority
  if (isCancelled) {
    console.log('Returning Cancelled badge');
    return <Badge className="bg-red-100 text-red-700 border-red-200 whitespace-nowrap">Cancelled</Badge>;
  }
  
  if (isCompleted) {
    console.log('Returning Completed badge');
    return <Badge className="bg-emerald-100 text-emerald-700 border-emerald-200 whitespace-nowrap">Completed</Badge>;
  }
  
  // If not completed in database, check if user is currently checked in
  if (isCheckedIn) {
    console.log('Returning In Session badge');
    return <Badge className="bg-blue-100 text-blue-700 border-blue-200 whitespace-nowrap">In Session</Badge>;
  }
  
  // Default to the booking status
  switch (status) {
    case "Confirmed":
      console.log('Returning Confirmed badge');
      return <Badge className="bg-green-100 text-green-700 border-green-200 whitespace-nowrap">Confirmed</Badge>;
    default:
      console.log('Returning default badge for status:', status);
      return <Badge variant="secondary" className="whitespace-nowrap">{status}</Badge>;
  }
};
